import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=10f1b640&scoped=true&"
import script from "./menus.vue?vue&type=script&lang=js&"
export * from "./menus.vue?vue&type=script&lang=js&"
import style0 from "./menus.vue?vue&type=style&index=0&id=10f1b640&scoped=true&lang=css&"
import style1 from "./menus.vue?vue&type=style&index=1&id=10f1b640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1b640",
  null
  
)

export default component.exports